module.exports = __webpack_public_path__ + "static/media/wishpanda-logo.24ad3e02.svg";